// removed by extract-text-webpack-plugin
module.exports = {"reviews":"reviews__3OkL3"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/views/User/components/Reviews/styles.scss
// module id = ./app/scripts/views/App/views/User/components/Reviews/styles.scss
// module chunks = 1